'use strict'
import angular from 'angular';

import tasksFilterComponentHtmlUrl from './tasksFilter.component.html';

angular.module('tasksFilter').component('tasksFilterSelector', {
    templateUrl: tasksFilterComponentHtmlUrl,
    bindings: {
        delegate: '<',
        optionsProviderName: '@',
        isShowingSaveIcon: '@'
    },
    controller(TasksFilterOptionsProviderFactory) {
        this.show = false
        this.field = ''
        this.optionsForField = []
        this.comparator = ''
        this.optionsForComparator = []
        this.boundary = ''
        this.errors = []

        const NAMES = ['comparator', 'field', 'boundary']

        let wasApplied = false,
            defaultValues = {}

        this.$onInit = () => {
            let optionsProvider = TasksFilterOptionsProviderFactory.makeOptionsProviderFor(this.optionsProviderName)
            if(!validateOptionsProvider(optionsProvider)) {
                return
            }

            this.optionsForField = optionsProvider.optionsForField
            this.optionsForComparator = optionsProvider.optionsForComparator

            optionsProvider.defaultValues((values) => {
                defaultValues = values
                setDefaultValues.call(this)
                this.show = true
            })
        }

        function validateOptionsProvider(optionsProvider) {
            return optionsProvider.optionsForField.length > 0 && optionsProvider.optionsForComparator.length > 0
        }

        function setDefaultValues() {
            NAMES.forEach((name) => {
                if (name === 'boundary') {
                    this[name] = defaultValues[name] ? parseInt(defaultValues[name]) : ''
                } else {
                    this[name] = defaultValues[name] || ''
                }
            })
        }

        this.applyFilter = () => {
            wasApplied = true
            validates.call(this)

            if (this.errors.length === 0) {
                this.delegate.onApplyFilter(`${this.field}:${this.comparator}:${this.boundary}`)
            }
        }

        function validates() {
            this.errors = [];
            NAMES.forEach((propertyName) => {
                if (propertyName === 'boundary') {
                    validatesPresenceOf.call(this, propertyName)
                    validatesIsAnInteger.call(this, propertyName)
                } else {
                    validatesPresenceOf.call(this, propertyName)
                }
            })
        }

        function validatesPresenceOf(name) {
            if (this[name] !== '') {
                return
            }

            this.errors.push({
                for: name,
                message: `${name.capitalize()} is required`
            })
        }

        function validatesIsAnInteger(name) {
            let value = this[name]
            if (value === '') {
                return
            }

            if (isAnInteger(value)) {
                this.errors.push({
                    for: name,
                    message: `${name.capitalize()} must be a number`
                })
                return
            }

            function isAnInteger(value) {
                return !/^-?\d+$/.test(value)
            }
        }

        this.onDataChange = () => {
            if (wasApplied) {
                validates.call(this)
            }
        }

        this.resetFilter = () => {
            this.field = ''
            this.comparator = ''
            this.boundary = ''
            this.errors = []
            this.delegate.onResetFilter()
        }
    },
    controllerAs: 'vm'
})